/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaCollapsibleCollapsed/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Children from 'Simple/Children'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function TysiaCollapsibleCollapsed({
  children,
  viewPath = "/DesignSystem/TysiaCollapsible/TysiaCollapsibleCollapsed",
  isOpen
  
}) {
  return (<React.Fragment
>
<fromFlow.When is={!isOpen}>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</fromFlow.When>
</React.Fragment>)
}